import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=03824a64&lang=pug&"
import script from "./DriverList.vue?vue&type=script&lang=ts&"
export * from "./DriverList.vue?vue&type=script&lang=ts&"
import style0 from "./DriverList.vue?vue&type=style&index=0&id=03824a64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports